module.exports = __webpack_public_path__ + "static/media/FBSEF.4e6ee30d.jpg";